import { IPlayerGame } from '@grassrootly/api/entities';
import { provider } from "@grassrootly/api/providers";

export interface GetPlayerFeaturedGamePayload {
  pid?: number;
}

export const GetPlayerFeaturedGame = async (payload?: GetPlayerFeaturedGamePayload): Promise<IPlayerGame | null> =>
  provider.Request("/featured-game", payload || {});
